import { deleteResource } from '../api/gas';
export default async (id, logger) => {
    return deleteResource(`invite`, id, logger);
};
